module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-sidebar"
  }, [_c('div', {
    staticClass: "right-content"
  }, [_vm._m(0), _vm._v(" "), (_vm.isLogin) ? _c('div', {
    staticClass: "login-out"
  }, [_c('img', {
    staticClass: "head-img",
    attrs: {
      "src": _vm.$store.getters.face
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Hi~" + _vm._s(_vm.name))]), _vm._v(" "), _c('ul', {
    staticClass: "head-ul-orad"
  }, [_c('li', [_c('router-link', {
    staticClass: "p1",
    attrs: {
      "to": "/member/order?status=5"
    }
  }, [_vm._v(_vm._s(_vm.waitconfirmCount))]), _vm._v(" "), _c('p', [_vm._v("待收货")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "p1",
    attrs: {
      "to": "/member/order?status=2"
    }
  }, [_vm._v(_vm._s(_vm.waitrogCount))]), _vm._v(" "), _c('p', [_vm._v("待发货")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "p1",
    attrs: {
      "to": "/member/order?status=0"
    }
  }, [_vm._v(_vm._s(_vm.notpayCount))]), _vm._v(" "), _c('p', [_vm._v("待付款")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "p1",
    attrs: {
      "to": "/member/comments?tab=2"
    }
  }, [_vm._v(_vm._s(_vm.waitcommentCount))]), _vm._v(" "), _c('p', [_vm._v("待评价")])], 1)])]) : _c('div', {
    staticClass: "login-out"
  }, [_c('img', {
    staticClass: "head-img",
    attrs: {
      "src": "//static.kxymall.com/images/default_face.jpg"
    }
  }), _vm._v(" "), _c('h2', [_vm._v("Hi~欢迎来逛逛")]), _vm._v(" "), _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/login",
      "title": "会员登录"
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('router-link', {
    staticClass: "button",
    attrs: {
      "to": "/register",
      "title": "会员注册"
    }
  }, [_vm._v("注册")])], 1), _vm._v(" "), _c('div', {
    staticClass: "mall-news"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("开心云商快讯")]), _vm._v(" "), _c('ul', {
    staticClass: "mall-news"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: item.id
    }, [_c('span', {
      staticClass: "mall-news-tips"
    }, [_vm._v("推荐")]), _vm._v(" "), _c('router-link', {
      staticClass: "mall-new-li",
      attrs: {
        "to": {
          path: '/help',
          query: {
            articleid: item.id,
            new: 1
          }
        },
        "title": item.page_title,
        "target": "_blank"
      }
    }, [_vm._v("\n            " + _vm._s(item.page_title) + "\n          ")])], 1)
  }), 0)]), _vm._v(" "), _vm._l((_vm.advList), function(item, index) {
    return (_vm.advList.length > 0 && index < 2) ? _c('div', {
      key: item.key,
      staticClass: "a"
    }, [_c('a', {
      attrs: {
        "href": item.url,
        "target": "_blank",
        "title": item.aname
      }
    }, [_c('img', {
      attrs: {
        "src": item.atturl,
        "alt": item.aname,
        "width": "100%",
        "height": "97px"
      }
    })])]) : _vm._e()
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "policy"
  }, [_c('img', {
    attrs: {
      "src": "//static.kxymall.com/images/CP.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c94b89f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/banner/flashNewsList.vue
// module id = 1601
// module chunks = 1